import React, { useState } from 'react';
import cx from 'classnames';
import { slugFormat } from '../../../../utils/functions';
import { cellPhone, preventTrunc } from '../../../../utils/mask';
import { SeeAddressMobile } from '../../common/SeeAddress';
import styles from '../style.module.css';
import { AvatarPerson } from './AvatarPerson';
import { RevealPhone } from './RevealPhone';
import { VehicleStoreOrPerson } from './VehicleStoreOrPerson';

interface AddressProps {
  city: string;
  cepAddress: string;
  district: string;
  street: string;
  additionalAddressData: string;
}
interface DataProps {
  bgColor: string;
  urlImg: string;
  nameStore: string;
  phone: string;
  address: AddressProps;
  s3: string;
  id: number;
  type: string;
}
interface Props {
  dataStore: DataProps;
  dataValue?: string;
  telephoneAsLink?: boolean;
}
export const SummaryMobile = ({ dataStore, dataValue, telephoneAsLink = false }: Props) => {
  const { urlImg, nameStore, phone, address, s3, bgColor, id, type } = dataStore;
  const [hasSeePhone, setHasSeePhone] = useState(false);

  const logoBox = cx('br-100 overflow-hidden ba b--boulder', styles.logoStoreData);
  const truncatePhone = cx('transition-ease', {
    [styles.truncateText]: !hasSeePhone,
    'mw-100': hasSeePhone,
  });

  const handleSeePhone = () => {
    if (hasSeePhone) {
      return null;
    }
    setHasSeePhone(!hasSeePhone);
  };

  const hasAvatar = () =>
    !urlImg ? (
      <AvatarPerson bgColor={bgColor} nameStore={nameStore} />
    ) : (
      <img src={`${s3}${urlImg}`} alt={nameStore} className="h-100 w-100" />
    );

  const renderUrl = () => {
    const city = address.city.split(' - ');
    return slugFormat(`/loja/${city[1]}/${city[0]}/${nameStore}/${id}`);
  };

  const renderLinkPersonOrSeeAddress = () => {
    if (type === '2') {
      return <SeeAddressMobile address={address} />;
    }
    return (
      <VehicleStoreOrPerson
        text="Veículos desse vendedor"
        url={renderUrl()}
        dataValue={dataValue}
      />
    );
  };
  const renderLinkStore = () => {
    if (type === '2') {
      return (
        <div className="flex justify-end">
          <VehicleStoreOrPerson text="Veículos dessa loja" url={renderUrl()} />
        </div>
      );
    }
    return null;
  };

  const TelephoneLink: React.FC = ({ children }) =>
    telephoneAsLink ? (
      <a href={`tel:${phone}`} title={phone}>
        {children}
      </a>
    ) : (
      <>{children}</>
    );

  return (
    <div className="flex flex-column relative">
      <div className="flex items-center">
        <div className={logoBox}>{hasAvatar()}</div>

        <div className="ml12">
          <h2 className="f18 fw6 abbey ma0 mb4">{nameStore}</h2>
        </div>
      </div>

      <div className="mt12 mb24">
        <div className="flex items-center mb8">
          <div className={truncatePhone}>
            <TelephoneLink>
              <p className="f14 abbey fw3 ma0 truncate">{cellPhone(preventTrunc(phone))}</p>
            </TelephoneLink>
          </div>
          <RevealPhone hasSeePhone={hasSeePhone} onClick={handleSeePhone} dataValue={dataValue} />
        </div>

        <div className="flex items-center">{renderLinkPersonOrSeeAddress()}</div>
      </div>
      {renderLinkStore()}
    </div>
  );
};
